"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ["M15.399 9.01L1.527 15.875c-.535.267-1.175.081-1.421-.427A.953.953 0 010 15V10l8-2-8-2V1c0-.528.407-1 1.004-1 .169 0 .416.04.567.116L15.403 7.07a1.084 1.084 0 01-.005 1.939z"];
//# sourceMappingURL=send-message.js.map